import { Box } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const ContentSwitchActiveBox = styled(Box)`
   display: block;
   //margin-top: -5px;
   padding: 16px;
   box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
   border-radius: 8px;
   border-top-left-radius: 0;
   border-top-right-radius: 0;
   margin-bottom: 16px;

  @media (max-width: 568px) {
    padding: 0;
  }

  ${(props) =>
    props.timer &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.hideBoxShadow &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
        box-shadow: none;
      }
    `}

  ${(props) =>
    props.boxShadowNone &&
    css`
      box-shadow: none;

      @media (max-width: 767px) {
        box-shadow: none;
      }
    `}

  ${(props) =>
    props.insideSetting &&
    css`
      @media (max-width: 568px) {
        padding: 15px;
      }
    `}

  ${(props) =>
    props.isHidden &&
    css`
      display: none;
    `}

}
`;

export const ContentSwitchIcon = styled.img`
  width: 18px;
  height: 18px;

  ${(props) =>
    props.isAbsoluteRight &&
    css`
      position: absolute;
      right: 0;
      background: #ebeffe;
      border-radius: 50%;
    `}

  ${(props) =>
    props.isRequest &&
    css`
      width: 22px;
      height: 22px;
    `}

  ${(props) =>
    props.iconSize &&
    css`
      width: ${props.size};
      height: ${props.size};
    `}


  ${(props) =>
    props.title === 'Donations' &&
    css`
      width: 28px;
      height: 28px;
    `}

  ${(props) =>
    props.title === 'Digital goods' &&
    css`
      width: 15px;
      height: 15px;
    `}

  ${(props) =>
    props.title === 'Shipping' &&
    css`
      width: 24px;
      height: 24px;
    `}
`;

export const ContentSwitchTitleText = styled(Box)`
  margin-right: 15px;
  white-space: nowrap;
  min-width: fit-content;

  @media (max-width: 480px) {
    min-width: fit-content;
  }
`;

export const ContentSwitchTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-left: 20px;

  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 38px;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.isContent &&
    css`
      align-items: center;
      flex-direction: row;
      flex: 1;
      min-width: 0;
    `}

  ${(props) =>
    props.isNoIcon &&
    css`
      margin-left: 0;
    `}

  ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.subsection &&
    css`
      width: 100%;
      white-space: initial;
    `}
`;

export const ContentSwitchSubtitle = styled.span`
  font-size: 14px;
  line-height: 1.2;
  color: var(--secondary-gray);
  margin-top: 2px;
  white-space: wrap;

  @media (max-width: 576px) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
      }
    `}

  ${(props) =>
    props.isBottom &&
    css`
      position: absolute;
      bottom: -15px;
      left: 5px;
    `}
  ${(props) =>
    props.isShorter &&
    css`
      max-width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${(props) =>
    props.isRelative &&
    css`
      position: relative;
    `}
  ${(props) =>
    props.ellipsis &&
    css`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}
`;

export const ContentSwitchBox = styled(Box)`
  display: flex;
  align-items: center;
  padding-left: 0;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isNoFlex &&
    css`
      @media (max-width: 568px) {
        flex: none;
      }
    `}

  ${(props) =>
    props.isNoFlexDesctop &&
    css`
      flex: none;
    `}


  ${(props) =>
    props.noDisplay &&
    css`
      display: none;
    `}

  ${(props) =>
    props.click &&
    css`
      cursor: pointer;
      padding: 12px 5px 12px 15px;
      flex-grow: 1;
    `}

  ${(props) =>
    props.lock &&
    css`
      cursor: pointer;
      padding: 0 10px;
      flex-grow: 1;
    `}



  ${(props) =>
    props.module &&
    css`
      cursor: pointer;
      padding: 12px 5px 12px 0;
      flex-grow: 1;
    `}


  ${(props) =>
    props.dragSection &&
    css`
      @media (max-width: 568px) {
        padding-left: 35px;
      }
    `}



  ${(props) =>
    props.isSwitchActive &&
    css`
      // min-width: 130px;
      // flex-basis: 130px;
      justify-content: flex-end;
    `}

  ${(props) =>
    props.isSwitch &&
    css`
      //min-width: 68px;
      //flex-basis: 68px;

      @media (max-width: 568px) {
        min-width: 38px;
        flex-basis: 38px;
      }
    `}

  ${(props) =>
    props.isEditBox &&
    css`
      min-width: 80px;
      flex-basis: 80px;
    `}

  ${(props) =>
    props.isDesignSwitch &&
    css`
      min-width: 30px;
      flex-basis: 30px;
    `}

  ${(props) =>
    props.isAddedSection &&
    css`
      min-width: 30px;
      flex-basis: 30px;
      color: #609afa;
      font-size: 32px;
    `}

  ${(props) =>
    props.isAdded &&
    css`
      color: var(--text-tertiary);
    `}

  ${(props) =>
    props.isNotSection &&
    css`
      //min-width: 68px;
      //flex-basis: 68px;

      @media (max-width: 568px) {
        min-width: 38px;
        flex-basis: 38px;
      }
    `}

  ${(props) =>
    props.insideMedia &&
    css`
      min-width: 37px;
      flex-basis: 37px;

      @media (max-width: 568px) {
        min-width: 38px;
        flex-basis: 38px;
      }
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
        flex-basis: auto;
        min-width: auto;
      }
    `}

  ${(props) =>
    props.isHighlight &&
    css`
      min-width: 140px;
      flex-basis: 140px;

      @media (max-width: 767px) {
        flex-basis: auto;
        min-width: auto;
      }
    `}

  ${(props) =>
    props.isShowing &&
    css`
      @media (max-width: 568px) {
        padding-left: 0;
      }
    `}

  ${(props) =>
    props.isRightMobile &&
    css`
      @media (max-width: 568px) {
        position: relative;
        right: -15px;
      }
    `}

  ${(props) =>
    props.isAdded &&
    css`
      opacity: 0.4;
      cursor: default;
    `}
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.linkItem &&
    css`
      scale: 1.7;
      padding: 5px;
      margin-left: 12px;
      position: relative;
      left: 7px;
    `}
`;

export const ContentSwitchIconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 36px;
  min-width: 36px;
  width: 36px;
  height: 36px;
  background: var(--accent-background);
  border-radius: 50%;

  [data-theme='dark'] & {
    background: rgba(123, 97, 255, 0.15);
  }

  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
`;

export const ContentSwitchContainer = styled(Box)`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
  border-radius: 8px;
  position: relative;
  padding: 0 2px;

  ${(props) =>
    props.active &&
    css`
      position: relative;
      margin-bottom: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      &:after {
        content: '';
        position: absolute;
        bottom: -15px;
        left: 0;
        width: 100%;
        height: 25px;
        background: var(--main-background);
        z-index: 0;
      }
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.isAddedSection &&
    css`
      cursor: pointer;
      padding: 10px;
    `}

  ${(props) =>
    props.isAdded &&
    css`
      opacity: 0.4;
      cursor: default;
    `}

  ${(props) =>
    props.isNotSoon &&
    css`
      pointer-events: none;
      cursor: default;
    `}




  ${(props) =>
    props.isNote &&
    css`
      &:after {
        position: absolute;
        top: 33px;
        right: 50px;
        width: 36px;
        height: 20px;
        font-size: 9px;
        color: #fff;
        text-align: center;
        line-height: 20px;
        border-radius: 10px;
        margin-top: -10px;
      }
    `}


  ${(props) =>
    props.isSoon &&
    css`
      cursor: default;

      &:after {
        content: 'SOON';
        background: #007aff;
      }
    `}

    ${(props) =>
    props.isProPlan &&
    css`
      &:after {
        content: 'PRO';
        background: #39e09b;
      }
    `}

  ${(props) =>
    props.isNotSection &&
    css`
      opacity: 1;
      cursor: pointer;
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      @media (max-width: 767px) {
        margin: 12px 0;
        box-shadow: none;
        padding-right: 5px;

        &:after {
          display: none;
        }
      }
    `}

  ${(props) =>
    props.isMarginTop &&
    css`
      margin-top: 15px;
    `}
`;

export const ContentSwitchHeader = styled(Box)`
  margin-bottom: 30px;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ContentSwitchHeaderPromo = styled(Box)`
  font-size: 12px;
  line-height: 16px;
`;

export const ContentSwitchHeaderPromoLink = styled.span`
  margin-left: 2px;
  text-decoration: underline;
  color: #00bfff;
  cursor: pointer;
`;
